<h1 mat-dialog-title>Promote Driver</h1>

<mat-dialog-content>
  <p>Promote Driver to Supervisor or Admin</p>

  <form [formGroup]="userForm">
    <p>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>User role</mat-label>
        <mat-select formControlName="userType">
          @for (userType of userTypes; track userType) {
            <mat-option [value]="userType">{{ userType.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Email</mat-label>
        <input matInput autocomplete="off" formControlName="emailPrefix" required />
        <span matTextSuffix>{{ configuration.driverSuffix }}</span>
        @if (ngEmailPrefix?.invalid && ngEmailPrefix?.errors?.required) {
          <mat-error> Email is required. </mat-error>
        }
        @if (ngEmailPrefix?.invalid && ngEmailPrefix?.errors?.pattern) {
          <mat-error> Email format is not valid. </mat-error>
        }
      </mat-form-field>
    </p>

    @if (uiError) {
      <p class="ui-error">
        {{ uiError }}
      </p>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!isSaving) {
    <button mat-stroked-button mat-dialog-close>Cancel</button>
  }
  @if (!isSaving) {
    <button mat-flat-button color="primary" [disabled]="!userForm.valid" (click)="performSave()">Save</button>
  }
  @if (isSaving) {
    <mat-spinner [diameter]="18"></mat-spinner>
  }
</mat-dialog-actions>
